module.exports = __webpack_public_path__ + "static/media/4.5927a976.png";